<template>

  <body class="A4">
    <report-sheet-defect-lv v-if="category == 'lv'" :district="district" :source="source" :feeder="feeder"
      :category="category" :pole="pole" :poleModel="poleModel" :filters="filters" :voltage="voltage" :load="load"
      :humidity="humidity" :temperature="temperature" :redisRoute="redisRoute" sheetType="defect"
      @defectVerified="defectVerified" @isLoading="isLoading" @toggleModal="toggleModal" />
    <report-sheet-defect v-else :district="district" :source="source" :feeder="feeder" :category="category" :pole="pole"
      :poleModel="poleModel" :filters="filters" :voltage="voltage" :load="load" :humidity="humidity"
      :temperature="temperature" :redisRoute="redisRoute" sheetType="defect" @defectVerified="defectVerified"
      @isLoading="isLoading" @toggleModal="toggleModal" />

    <template v-if="filters.type == 'Full'">
      <report-sheet-overview :district="district" :source="source" :pole="pole" :filters="filters" :voltage="voltage"
        :load="load" :humidity="humidity" :temperature="temperature" sheetType="visual" @toggleModal="toggleModal" />
      <report-sheet-overview :district="district" :source="source" :feeder="feeder" :category="category" :pole="pole"
        :filters="filters" :voltage="voltage" :load="load" :humidity="humidity" :temperature="temperature"
        sheetType="thermal" @toggleModal="toggleModal" />
    </template>
  </body>
</template>

<script>
import ReportSheetDefect from "@/components/ReportSheetDefect";
import ReportSheetDefectLV from "@/components/ReportSheetDefectLV";
import ReportSheetOverview from "@/components/ReportSheetOverview";

export default {
  name: "reportViewer",
  props: [
    "district",
    "source",
    "feeder",
    "category",
    "pole",
    "poleModel",
    "filters",
    "voltage",
    "load",
    "temperature",
    "humidity",
    "redisRoute",
  ],
  components: {
    "report-sheet-defect": ReportSheetDefect,
    "report-sheet-defect-lv": ReportSheetDefectLV,
    "report-sheet-overview": ReportSheetOverview,
  },
  methods: {
    isLoading(show) {
      this.$emit("isLoading", show);
    },
    defectVerified(e) {
      this.$emit("defectVerified", e);
    },
    toggleModal(name, show, images, index, caption) {
      this.$emit("toggleModal", name, show, images, index, caption);
    },
  },
};
</script>

<style>
@page {
  size: A4;
}

body.A4 {
  background-color: #f5f7fa;
}
</style>
